import { FaPhoneAlt,FaMapMarkerAlt } from 'react-icons/fa';
import {MdEmail} from 'react-icons/md'

import TopSpace from '../../components/TopSpace';
import BannerContact from "../../components/banners/BannerContact";
import ContactClient from "./ContactClient";
import useDocumentTitle from '../../hooks/useDocumentTitle';

const Contact = () => {
    useDocumentTitle('Contact Us')

    const bannerContent = {
        heading:"Contact us",
        description:"Got a question or need more info? We're on standby to help. <br />Just enter your details and we'll be with you shortly.  <br />Or, give us a call on <a href='tel:+611800595456'>1800 595 456</a>.",
        locations:[
            {
                area:"Lucknow",
                address:"417/245 Niwajganj Panniwali Gali Thakurganj, Chowk Lucknow Uttar Pradesh, India"
            },
            {
                area:"Noida",
                address:"417/245 Niwajganj Panniwali Gali Thakurganj, Chowk Lucknow Uttar Pradesh, India"
            },
            {
                area:"Germany",
                address:"417/245 Niwajganj Panniwali Gali Thakurganj, Chowk Lucknow Uttar Pradesh, India"
            },
            {
                area:"Australia",
                address:"417/245 Niwajganj Panniwali Gali Thakurganj, Chowk Lucknow Uttar Pradesh, India"
            }
        ]
    }

    const contactCard = [
        {
            icon:<FaPhoneAlt size={25} />,
            title:"Phone",
            description:"You can always reach out to us Mon-Sat, 10:00 am to 7:00 pm",
            contact:[
                {label:"+91 1234567890 (India)",link:"tel:91 1234567890",target:"_self"},
                {label:"+91 1234569870 (India)",link:"tel:1234569870 ",target:"_self"}
            ]
        },
        {
            icon:<MdEmail size={25}/>,
            title:"Email",
            description:"Our support team will get back to in 8-h during standard business hours.",
            contact:[
                {label:"dummymail@exmple.com ",link:"mailto:dummymail@exmple.com",target:"_self"}
            ]
        },
        {
            icon:<FaMapMarkerAlt size={25} />,
            title:"Address",
            description:"Our local address",
            contact:[
                {label:"417/245 Niwajganj panni wali Gali Thakurganj Chowk, Lucknow",link:"google.com/map",target:"_blank"}
            ]
        },
    ]
    return (
        <TopSpace>
            <BannerContact 
                heading={bannerContent.heading}
                description={bannerContent.description}
                locations={bannerContent.locations}
            />
            
            <ContactClient 
                contactCard={contactCard}
            />
        </TopSpace>
    );
};

export default Contact;